import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { loadRiskDisclaimer } from '../utils/legalLoader';
import LandingNav from '../components/shared/LandingNav';
import Seo from '../components/Seo';

const RiskDisclosure = () => {
  const [legalContent, setLegalContent] = useState(null);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => { 
    window.scrollTo(0, 0);
    
    loadRiskDisclaimer().then(content => {
      setLegalContent(content);
      setLoading(false);
    });
  }, []);

  return (
    <div style={{ padding: '24px 0' }}>
      <Seo
        title="Risk Disclosure | PrecisionTrader"
        description="PrecisionTrader Risk Disclosure — important information about the risks of trading."
        canonicalPath="/risk-disclosure"
      />
      {/* Navigation (match Landing/Pricing style) */}
      <LandingNav />
      <div style={{ maxWidth: 900, margin: '0 auto', padding: '0 16px' }}>
        {loading ? (
          <div>Loading...</div>
        ) : legalContent ? (
          <>
            <h1 style={{ marginBottom: 8 }}>{legalContent.title}</h1>
            {legalContent.lastUpdated && (
              <div style={{ color: 'var(--text-light)', marginBottom: 24 }}>
                Last Updated: {legalContent.lastUpdated}
              </div>
            )}

            {legalContent.sections.map((section, idx) => (
              <div key={idx} style={{ margin: '24px 0' }}>
                {/* Only show section title if it exists */}
                {section.title && <h3 style={{ marginTop: 24, marginBottom: 12 }}>{section.title}</h3>}
                <div style={{ opacity: 0.95 }}>
                  {section.content.map((item, itemIdx) => {
                    if (item.type === 'paragraph') {
                      return <p key={itemIdx} style={{ marginBottom: 16 }}>{item.text}</p>;
                    } else if (item.type === 'bullet') {
                      return (
                        <ul key={itemIdx} style={{ marginLeft: 0, paddingLeft: 20 }}>
                          <li>{item.text}</li>
                        </ul>
                      );
                    } else if (item.type === 'strong') {
                      // For STRONG items in risk disclaimer, render as paragraph with bold label
                      const parts = item.text.split(':');
                      if (parts.length >= 2) {
                        return (
                          <p key={itemIdx} style={{ marginBottom: 16 }}>
                            <strong>{parts[0]}:</strong> {parts.slice(1).join(':')}
                          </p>
                        );
                      }
                      return <p key={itemIdx} style={{ marginBottom: 16 }}><strong>{item.text}</strong></p>;
                    }
                    return null;
                  })}
                </div>
              </div>
            ))}

            <div style={{ marginTop: 32, display: 'flex', gap: '24px', paddingTop: 24, borderTop: '1px solid rgba(255,255,255,0.1)' }}>
              <Link to="/terms" style={{ color: 'var(--accent)' }}>View Terms of Service</Link>
              <Link to="/privacy" style={{ color: 'var(--accent)' }}>View Privacy Policy</Link>
            </div>
          </>
        ) : (
          <div>Error loading risk disclosure</div>
        )}
      </div>
    </div>
  );
};

export default RiskDisclosure;





